import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/Contemporary_Period_-_Rise_of_China.png';

function HistoryPageRiseOfChinaGo() {
  return (
    <QuizPage
      title="History: Rise of China"
      subTopic="Rise of China"
      backgroundImage={historyImage}
      returnPath="/History-Rise-of-China"
    />
  );
}

export default HistoryPageRiseOfChinaGo;
